import { useRouter } from "next/navigation";

type UseSpecieCardProps = {
  species: string;
};

export const useSpeciesCard = ({ species }: UseSpecieCardProps) => {
  const router = useRouter();

  const handleOnClick = () => {
    return router.push(`/racas/${species}`);
  };

  return {
    handleOnClick
  };
};
